/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { selectCorrectOption, setQBProperty } from 'state/actions/embedsState/embedManagementState/content_status';
// component
import Correct from 'material/embeds/content/edit/correct/correct';



/* ========== ~~~~~~~~~~ EMBED : EDIT : CORRECT : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }, { contentId, optionId }) => ({
    correctOptionSelected: embedsState.embedManagementState.contentStatus['contents'][contentId]['questionBased']['correctOptionSelected'],
    correctOption: embedsState.embedManagementState.contentStatus['contents'][contentId]['questionBased']['options'][optionId]['correctOption'],
    contentType: embedsState.embedManagementState.contentStatus['contents'][contentId]['contentType']
});
const mapDispatchToProps = dispatch => ({
    selectCorrectOption: (optionId) => dispatch(selectCorrectOption(optionId)),
    setQBProperty: (contentId, property, value) => dispatch(setQBProperty(contentId, property, value))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Correct);
